import * as React from "react"
import styled from "styled-components"
import { Spacer } from "../spacers"
import { theme } from "../../theme"
import { getVariantColor, getVariantHoverColor } from "../../../utils/theme-helpers"

interface ButtonProps {
  onClick?: () => void
  icon: React.ReactNode
  disabled?: boolean
  selected?: boolean
  variant?: "light" | "dark" | "blue" | "yellow" | "red" | "green"
}

const ButtonContainer = styled.button<{
  backgroundColor: string
  hoverColor: string
  disabled?: boolean
  selected?: boolean
  variant: "light" | "dark" | "blue" | "yellow" | "red" | "green"
}>`
  cursor: ${(props) => (props.disabled ? undefined : "pointer")};
  border: ${(props) => (props.variant === "light" ? `1px solid ${props.theme.colors.greyDark}` : "none")};
  border-radius: ${(props) => props.theme.borders.buttonRadius};
  background: ${(props) => (props.selected ? props.theme.colors.greyDark : props.backgroundColor)};
  display: flex;
  align-items: center;
  ${(props) => props.disabled && "background: #C3C3C3"};
  width: 51px;
  height: 51px;
  justify-content: center;
  padding: ${(props) => props.theme.spacings.medium};
  box-shadow: 0px 1px 3px 1px rgba(119, 119, 119, 0.25);

  :hover {
    background: ${(props) => (props.disabled ? undefined : props.hoverColor)};
  }
  :active {
    box-shadow: none;
  }
`

const IconButton: React.FunctionComponent<ButtonProps> = ({ onClick, icon, disabled, selected, variant = "light" }) => {
  const [color, setColor] = React.useState(theme.colors.white)
  const [hoverColor, setHoverColor] = React.useState(theme.colors.greyLight)

  React.useMemo(() => {
    setColor(getVariantColor(variant))
    setHoverColor(getVariantHoverColor(variant))
  }, [variant])

  return (
    <ButtonContainer
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      selected={selected}
      variant={variant}
      hoverColor={hoverColor}
      backgroundColor={color}
    >
      {icon}
    </ButtonContainer>
  )
}

export default IconButton
